function pushUnique(targetIds, nextId) {
    if (!nextId || targetIds.includes(nextId)) {
        return;
    }

    targetIds.push(nextId);
}

export function buildCriticalMediaLoadIds(mediaScans, selectedIndex, visibleThumbnailIds = []) {
    const criticalIds = [];
    const visibleThumbnailIdSet = new Set(visibleThumbnailIds);
    const selectedScan = mediaScans[selectedIndex];

    pushUnique(criticalIds, selectedScan?.id);

    mediaScans.forEach((scan) => {
        if (visibleThumbnailIdSet.has(scan.id)) {
            pushUnique(criticalIds, scan.id);
        }
    });

    pushUnique(criticalIds, mediaScans[selectedIndex - 1]?.id);
    pushUnique(criticalIds, mediaScans[selectedIndex + 1]?.id);

    return criticalIds;
}

export function buildMediaLoadOrder(mediaScans, selectedIndex, visibleThumbnailIds = [], idleEligibleIds = []) {
    const orderedIds = buildCriticalMediaLoadIds(mediaScans, selectedIndex, visibleThumbnailIds);
    const idleEligibleIdSet = new Set(idleEligibleIds);

    mediaScans.forEach((scan) => {
        if (idleEligibleIdSet.has(scan.id)) {
            pushUnique(orderedIds, scan.id);
        }
    });

    return orderedIds;
}

export function getNextThumbnailLoadIds(
    desiredLoadOrder,
    thumbnailStatesById,
    activeLoadIds,
    maxConcurrency,
) {
    const nextLoadIds = [];
    const activeLoadIdSet = new Set(activeLoadIds);

    desiredLoadOrder.forEach((scanId) => {
        if (nextLoadIds.length >= maxConcurrency) {
            return;
        }

        if (activeLoadIdSet.has(scanId)) {
            return;
        }

        const thumbnailState = thumbnailStatesById[scanId];

        if (thumbnailState?.status === 'loading' || thumbnailState?.status === 'ready' || thumbnailState?.status === 'failed') {
            return;
        }

        nextLoadIds.push(scanId);
    });

    return nextLoadIds;
}
